// extracted by mini-css-extract-plugin
export default {"calender":"newscalender_calender__E1zOL"};